// EmptyState — pebble illustration + title/message + optional action.

import type { ReactNode } from "react";

export interface EmptyStateProps {
  title: string;
  message?: string;
  action?: ReactNode;
  illustration?: ReactNode;
}

function DefaultPebble() {
  return (
    <span className="lex-empty__pebble" aria-hidden="true">
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M5 7c3-3 11-3 14 0s3 11 0 14-11 3-14 0-3-11 0-14z" />
      </svg>
    </span>
  );
}

export function EmptyState({ title, message, action, illustration }: EmptyStateProps) {
  return (
    <div className="lex-empty" role="status">
      {illustration ?? <DefaultPebble />}
      <div className="lex-empty__title">{title}</div>
      {message ? <div className="lex-empty__desc">{message}</div> : null}
      {action}
    </div>
  );
}

export default EmptyState;
